/**
 * userApi.js
 * ユーザー・組織管理API（drone-ops-users-api Lambda）
 * src/services/userApi.js として配置
 */

import { getSession } from './auth';

const API_BASE = process.env.REACT_APP_API_ENDPOINT;

async function authHeaders() {
  const session = await getSession();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${session.idToken}`,
  };
}

/**
 * 新規ユーザー登録（Cognito確認後に呼び出す）
 * Organizations + Users テーブルに登録
 */
export async function registerUser({ email, name, orgType, orgName }) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users/register`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ email, name, orgType, orgName }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.message || '登録に失敗しました');
  }
  return res.json();
}

/**
 * 自分のプロフィール取得
 */
export async function getMyProfile() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users/me`, { headers });
  if (!res.ok) throw new Error('プロフィールの取得に失敗しました');
  return res.json();
}

/**
 * 組織メンバー一覧取得（adminのみ）
 */
export async function getOrgMembers() {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users`, { headers });
  if (!res.ok) throw new Error('メンバー一覧の取得に失敗しました');
  return res.json();
}

/**
 * メンバー招待（adminのみ）
 */
export async function inviteMember({ email, role }) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users/invite`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ email, role }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.message || '招待に失敗しました');
  }
  return res.json();
}

/**
 * 組織にアップグレード（個人→組織）
 */
export async function upgradeToOrganization({ orgName }) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users/upgrade`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ orgName }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.message || 'アップグレードに失敗しました');
  }
  return res.json();
}

/**
 * 招待トークンの確認
 */
export async function getInvitation(token) {
  const res = await fetch(`${API_BASE}/users/invite/${token}`);
  if (!res.ok) throw new Error('招待が見つかりません');
  return res.json();
}

/**
 * 招待を承認（既存個人ユーザーの組織参加）
 */
export async function acceptInvitation({ token, transferData }) {
  const headers = await authHeaders();
  const res = await fetch(`${API_BASE}/users/invite/${token}/accept`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ transferData }),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.message || '招待の承認に失敗しました');
  }
  return res.json();
}

